import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import UpdateLicense from "../../Modals/updatelicense";

const TradeLicence = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  // Updated Dummy Data
  const data = [
    {
      id: 1,
      licenseName: "Trade License - TL-27834",
      uploadedDate: "2024-10-05",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-12-30",
    },
    {
      id: 2,
      licenseName: "MOA - MOA-98345",
      uploadedDate: "2024-08-11",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-08-15",
    },
    {
      id: 3,
      licenseName: "MOA  - MOA-55219",
      uploadedDate: "2024-09-21",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-01-10",
    },
    {
      id: 4,
      licenseName: "Trade License - TL-66102",
      uploadedDate: "2024-07-30",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-11-05",
    },
    {
      id: 5,
      licenseName: "MOA  - MOA-11987",
      uploadedDate: "2024-11-13",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-03-18",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Manage Licenses</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Licenses
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>

          <div className="right_s">
            <Button onClick={() => setOpenModal(true)} className="btn btn_primary">
              Update Document
            </Button>
          </div>
        </div>

        {/* TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Document Name</TableCell>
                <TableCell>Document Upload Date</TableCell>
                <TableCell>View Document</TableCell>
                <TableCell>Document Expiry Date</TableCell>
              </TableRow>
              
            </TableHead>

            <TableBody>
              {data.map((item, index) => (
                <TableRow hover key={item.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>{item.licenseName}</TableCell>

                  <TableCell>{item.uploadedDate}</TableCell>

                  <TableCell>
                    <Button className="btn btn_primary sm">
                      View Document
                    </Button>
                  </TableCell>

                  <TableCell>{item.expiryDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <UpdateLicense
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default TradeLicence;
